import html2canvas from 'html2canvas'

const _fixType = type => 'image/' + type.toLowerCase().replace(/jpg/i, 'jpeg').match(/png|jpeg|bmp|gif/)[0]
const saveFile = (data, filename) => {
  const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
  save_link.href = data
  save_link.download = filename
  const event = document.createEvent('MouseEvents')
  event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  save_link.dispatchEvent(event)
}
/**
 *
 * @param {*} ele       // dom节点选择器 ！！！！选择器,传选择器,谢谢
 * @param {*} type      // 导出图片类型
 * @param {*} fileName  // 导出图片名
 */
export default function getReportImage (ele, type, fileName) {
  const dom = document.querySelector(ele)
  const width = dom.offsetWidth + 10
  const height = dom.offsetHeight
  const options = {
    logging: true,
    width,
    height
  }
  return html2canvas(document.querySelector(ele), options).then(canvas => {
    const node = canvas.cloneNode(true)
    const ctx = node.getContext('2d')
    ctx.drawImage(canvas, 0, 0) // 复制canvas
    // 创建水印canvas
    const textNode = canvas.cloneNode(true)
    textNode.width = 200
    textNode.height = 100
    const ctxText = textNode.getContext('2d')
    ctxText.rotate(-(20 * Math.PI / 180)) // 旋转绘图
    ctxText.font = '15px Arial'
    ctxText.fillStyle = 'rgba(220,220,224,0.8)'
    ctxText.textAlign = 'center' // 居中方式
    ctxText.fillText('新华丝路', 75, 75)
    // 重复填充 水印canvas
    const pat = ctx.createPattern(textNode, 'repeat')
    ctx.rect(0, 0, node.width, node.height)
    ctx.fillStyle = pat
    ctx.fill()
    let imgData = node.toDataURL(type, 1)
    imgData = imgData.replace(_fixType(type), 'image/octet-stream')
    saveFile(imgData, `${fileName}.${type}`)
    return Promise.resolve()
  })
}
